<script>
    import { NavigationStore, PageStore } from '../stores/PageStore.svelte.js';

    let { isNavOpen = true } = $props();
</script>

<nav class="flex-1 overflow-y-auto" id="frontendNav">
    <ul class="space-y-2 p-4">
        {#each NavigationStore.tree as item}
            <li>
                <button
                    onclick={() => PageStore.set(item.url)}
                    class={`hover:bg-dwc-400 flex w-full cursor-pointer items-center
                    justify-start gap-3 rounded p-2 transition-all duration-300
                    ${PageStore.path === item.url ? 'bg-dwc-400' : ''}`}
                    title={item.label}>
                    <item.icon size="24" class="shrink-0" />

                    <span class={`${isNavOpen ? 'opacity-100' : 'opacity-0'} overflow-hidden text-lg transition-all`}>
                        {item.label}
                    </span>
                </button>

                {#if item.children.length > 0}
                    <ul class="mt-2 ml-6 space-y-2">
                        {#each item.children as child}
                            <li>
                                <button
                                    onclick={() => PageStore.set(child.url)}
                                    class={`hover:bg-dwc-400 flex w-full cursor-pointer items-center
                                    justify-start gap-3 rounded p-2
                                    ${PageStore.path === child.url ? 'bg-dwc-400' : ''}`}>
                                    <child.icon size="16" class="shrink-0" />

                                    <span
                                        class={`${isNavOpen ? 'opacity-100' : 'opacity-0'} overflow-hidden text-sm transition-all`}>
                                        {child.label}
                                    </span>
                                </button>
                            </li>
                        {/each}
                    </ul>
                {/if}
            </li>
        {/each}
    </ul>
</nav>
